import api from '../backend-api.js';


export default {

    async getListBarcodesLikeValue(barcodeValue) {
        return (await api.getData('/tag/listalike?barcodeValue=' + barcodeValue)).data;
    },

};